import { proxyApiEndpoint } from '@/environment'
import type { EvmCsvFormat } from '@/types'
import { createEvmChainList } from '@pkg/basic'

export const evmChains = createEvmChainList({
  proxyApiEndpoint,
  etherscanApiKey: '',
  fantomApiKey: '',
  oasysProxyUrl: proxyApiEndpoint,
  roninApiKey: '',
  zkfairProxyUrl: proxyApiEndpoint,
})

export const evmChainCsvFormatList: readonly EvmCsvFormat[] = [
  {
    chainId: 2020,
    csvId: 'ronin-explorer',
    name: 'CSV from The Ronin Block Explorer',
    hashColumn: 'Txhash',
    blockNumberColumn: 'Blockno',
    timestampColumn: 'UnixTimestamp',
    timestampType: 'unixtime',
  },
]
